import { Component, Input } from '@angular/core';

export interface AuditTrailItem {
  title: string;
  time?: string;
  description?: string;
  dotColor?: 'indigo' | 'blue' | 'dark' | 'emerald' | 'green' | 'rose' | 'red' | 'slate' | 'gray' | string;
  titleColor?: 'default' | 'rose' | 'emerald' | string;
  isNote?: boolean;
}

@Component({
  selector: 'app-audit-trail',
  templateUrl: './app-audit-trail.component.html',
  styleUrls: ['./app-audit-trail.component.scss'],
})
export class AppAuditTrailComponent {
  @Input() items: AuditTrailItem[] = [];
  @Input() customClass: string = '';
}
